<script setup lang="ts">
import { onMounted, ref, watch } from 'vue'
import RoomieChipSelector from '@lahaus-roomie/roomie/src/components/RoomieChipSelector/index.vue'
import type { FormChipSelectorComponentModule } from '@/components/BrandedV2/FormSearchFilters/ChipSelector/types'

withDefaults(defineProps<FormChipSelectorComponentModule.Props>(), {
  dataAttributes: {
    dataLh: { P: 'unknown', Z: 'unknown' }
  }
})
const model = defineModel<FormChipSelectorComponentModule.Props['modelValue']>({ required: true })
const { rt } = useI18n()
const { $useLhId } = useNuxtApp()
const itemsSelected = ref<string[]>([])

const emit = defineEmits(['change'])
const toggleItemSelected = (value: string): void => {
  if (itemsSelected.value.includes(value)) {
    itemsSelected.value = itemsSelected.value.filter(item => item !== value)
    return
  }

  const valuesToRemove = ['all', 'no']

  if (valuesToRemove.some(value => itemsSelected.value.includes(value))) {
    itemsSelected.value = itemsSelected.value.filter(item => !valuesToRemove.includes(item))
  }

  emit('change', value)

  if (['all', 'no'].includes(value)) {
    itemsSelected.value = [value]
    return
  }

  itemsSelected.value.push(value)
}

const resetSelectedItems = (): void => {
  itemsSelected.value = []
}

watch(itemsSelected, (newValue): void => {
  if (newValue && newValue.includes('all')) {
    model.value = []
    return
  }
  model.value = newValue
}, { deep: true })

onMounted((): void => {
  if (model.value?.length) itemsSelected.value = model.value as string[]
})

defineExpose({
  resetSelectedItems
})

</script>

<script lang="ts">
export default {
  name: 'FormChipSelector'
}
</script>

<template>
  <div class="flex flex-row flex-wrap gap-8">
    <RoomieChipSelector
      v-for="(option, index) in options"
      :id="`${id}-${index}`"
      :key="`${id}-${index}`"
      :data-lh-id="$useLhId({ ...dataAttributes.dataLh, A: (itemsSelected.includes(rt(option.value))) ? 'seleccionar' : 'deseleccionar', C: rt(option.label) })"
      class="my-4"
      :is-selected="itemsSelected.includes(rt(option.value))"
      @click="toggleItemSelected(rt(option.value) as unknown as string)">
      <template #content>
        <span class="text-16 whitespace-nowrap pointer-events-none">
          {{ rt(option.label) }}
        </span>
      </template>
    </RoomieChipSelector>
  </div>
</template>
